import { HDate, getHolidaysOnDate, flags } from '@hebcal/core';
import { getIsraelToday, addDaysToDate, dateStringToNoonUtc } from './israelTime';

/** Today in Israel, 'YYYY-MM-DD'. */
export function getTodayString(): string {
  return getIsraelToday();
}

/** Tomorrow in Israel, 'YYYY-MM-DD'. */
export function getTomorrowString(): string {
  return addDaysToDate(getIsraelToday(), 1);
}

/** Next Shabbos after `from` (a Shabbos itself gives the following week). */
export function getNextShabbos(from: string = getTodayString()): string {
  let diff = (6 - dateStringToNoonUtc(from).getUTCDay() + 7) % 7;
  if (diff === 0) diff = 7;
  return addDaysToDate(from, diff);
}

function findNextDay(from: string, maxDays: number, flag: number): string {
  for (let i = 1; i <= maxDays; i++) {
    const date = addDaysToDate(from, i);
    const holidays = getHolidaysOnDate(new HDate(dateStringToNoonUtc(date)), true) || [];
    if (holidays.some((h) => h.getFlags() & flag)) return date;
  }
  return from;
}

export function getNextRoshChodesh(from: string = getTodayString()): string {
  return findNextDay(from, 40, flags.ROSH_CHODESH);
}

export function getNextYomTov(from: string = getTodayString()): string {
  return findNextDay(from, 400, flags.CHAG);
}
